import React from 'react';

import { useGetList } from '@vlabs/api/luna-api/client';
import type { ListId } from '@vlabs/api/point-api/model';
import { QueueIcon } from '@vlabs/icons';
import { routes } from '@vlabs/shared/navigation/routes';
import { Link } from '@vlabs/uikit/components/controls/link/Link';
import { generatePath } from 'react-router-dom';

import { buildTestid } from '@vlabs/monokit/shared/lib/utils';

import st from './ListItem.module.sass';
import type { BaseDataItemProps } from '../base-data-item';
import { BaseDataItem } from '../base-data-item';

export interface ListItemProps extends Omit<BaseDataItemProps, 'title'> {
  listId?: ListId;
}

const displayName = 'ListItem';
const testid = buildTestid(displayName);

export function ListItem({
  listId = undefined,
  actions = undefined,
  className = undefined,
  'data-testid': dataTestId = 'list-item',
}: ListItemProps): React.JSX.Element | null {
  const getList = useGetList(listId ?? '', {
    query: { enabled: !!listId },
  });

  if (!listId) return null;

  return (
    <BaseDataItem
      actions={actions}
      className={className}
      title={(
        <React.Fragment>
          <QueueIcon className={st.Icon} />
          <Link
            className={st.Link}
            kind="secondary"
            size="medium"
            to={generatePath(routes.lists.read, { listId })}
          >
            {getList.data?.user_data}
          </Link>
        </React.Fragment>
      )}
      {...testid(dataTestId)}
    />
  );
}
